<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Paramétrage du profil</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (settings) {
            <div class="container">
                <mat-tab-group>
                    <mat-tab label="Général">
                        @if (followFolderRight) {
                            <div class="form-item">
                                <mat-checkbox class="primary-button" matInput [formControl]="showFollowedFoldersControl" [(ngModel)]="settings.showFolderFollow">
                                    Afficher le suivi des dossiers
                                </mat-checkbox>
                            </div>
                        }

                        <div class="form-item">
                            <mat-checkbox class="primary-button" matInput [formControl]="autoFilterControl" [(ngModel)]="settings.autoFiltersSaveAndRestore">
                                Activation de la sauvegarde et de la restauration automatique des filtres.
                            </mat-checkbox>
                        </div>

                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Vue par défaut</mat-label>
                                <mat-select [formControl]="defaultViewControl" [(ngModel)]="settings.defaultViewId">
                                    <mat-option [value]="-1">Aucune</mat-option>
                                    @for (view of accessibleViews; track view.id) {
                                        <mat-option data-select-listing-type-option [value]="view.id">{{ view.name }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </mat-tab>

                    <mat-tab label="Paramétrage des vues">
                        <div>
                            <div class="form-item">
                                <mat-form-field>
                                    <mat-label>Vue à paramétrer</mat-label>
                                    <mat-select [formControl]="viewControl" (selectionChange)="onViewChange($event.value)">
                                        @for (view of accessibleViews; track view.id) {
                                            <mat-option data-select-listing-type-option [value]="view.id">{{ view.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            @if (selectedViewSettings) {
                                <div class="form-item">
                                    <mat-form-field>
                                        <mat-label>Mise en page</mat-label>
                                        <mat-select [formControl]="viewDefaultLayoutControl" [(ngModel)]="selectedViewSettings.defaultViewLayout" required>
                                            @for (layout of layouts; track layout.id) {
                                                <mat-option data-select-listing-type-option [value]="layout.id">{{ layout.name }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (viewDefaultLayoutControl?.errors?.required && (viewDefaultLayoutControl?.dirty || viewDefaultLayoutControl.touched)) {
                                            <mat-error>Le champ 'Mise en page' est obligatoire.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <div class="form-item">
                                    <mat-form-field>
                                        <mat-label>Filtre par défaut</mat-label>
                                        <mat-select
                                            [formControl]="viewDefaultFilterControl"
                                            [(ngModel)]="selectedViewSettings.defaultViewPredefinedFilter"
                                            (selectionChange)="onViewPredefinedFilterChange($event.value)">
                                            <mat-option data-select-listing-type-option [value]="-1">Aucun</mat-option>
                                            @for (predefinedFilter of predefinedFilters; track predefinedFilter.id) {
                                                <mat-option data-select-listing-type-option [value]="predefinedFilter.id">{{ predefinedFilter.name }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="form-item">
                                    <mat-slider class="sectionsGroupsCountSlider" [max]="4" [min]="2" [step]="1" [discrete]="true">
                                        <input matSliderThumb [(ngModel)]="selectedViewSettings.sectionsGroupsCount" #ngSliderThumb="matSliderThumb" />
                                    </mat-slider>
                                    <mat-label>Nombre de groupes de sections (Détail d'un dossier)</mat-label>
                                </div>
                            }
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        }
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="!isValid">Enregistrer</button>
    </mat-card-actions>
</mat-card>
<ngx-spinner name="profile-settings-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
